const DETECTION_STORAGE_KEY = 'pragmatic-lang-detected';

function detectPreferredLocale(supportedLocales) {
  if (typeof navigator === 'undefined') return null;

  const languages = navigator.languages && navigator.languages.length
    ? navigator.languages
    : [navigator.language];

  for (const tag of languages) {
    if (!tag) continue;
    const prefix = tag.split('-')[0].toLowerCase();
    if (supportedLocales.includes(prefix)) return prefix;
  }

  return null;
}

function initLanguageDetection(header) {
  const languageToast = header.querySelector('[data-language-toast]');
  if (!languageToast) return;

  const currentLocale = (header.getAttribute('data-current-locale') || '').toLowerCase();
  if (!currentLocale) return;

  let alreadyDetected = false;
  try {
    alreadyDetected = Boolean(localStorage.getItem(DETECTION_STORAGE_KEY));
  } catch {
    return;
  }

  if (alreadyDetected) return;

  const languageLinks = Array.from(languageToast.querySelectorAll('[data-language-choice]'));
  if (!languageLinks.length) return;

  const supportedLocales = languageLinks
    .map((link) => (link.getAttribute('data-language-choice') || '').toLowerCase())
    .filter(Boolean);

  const detectedLocale = detectPreferredLocale(supportedLocales);
  if (!detectedLocale || detectedLocale === currentLocale) return;

  const revealTimeout = window.setTimeout(() => {
    try {
      localStorage.setItem(DETECTION_STORAGE_KEY, 'true');
    } catch {
      // ignore
    }

    languageToast.classList.remove('hidden');

    window.setTimeout(() => {
      languageToast.classList.add('hidden');
    }, 10000);
  }, 1500);

  languageLinks.forEach((link) => {
    link.addEventListener('click', () => {
      window.clearTimeout(revealTimeout);
      try {
        localStorage.setItem(DETECTION_STORAGE_KEY, 'true');
      } catch {
        // ignore
      }
    });
  });
}

export function initSiteHeader() {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;

  const toggleButton = header.querySelector('[data-header-toggle]');
  const mobileMenu = header.querySelector('[data-mobile-menu]');
  const iconMenu = header.querySelector('[data-icon-menu]');
  const iconClose = header.querySelector('[data-icon-close]');
  const mobileLinks = header.querySelectorAll('[data-mobile-link]');
  const openLabel = header.getAttribute('data-open-label') || 'Open menu';
  const closeLabel = header.getAttribute('data-close-label') || 'Close menu';

  const setScrolledState = () => {
    const scrolled = window.scrollY > 20;
    header.classList.toggle('bg-background/80', scrolled);
    header.classList.toggle('backdrop-blur-xl', scrolled);
    header.classList.toggle('border-b', scrolled);
    header.classList.toggle('border-border', scrolled);
    header.classList.toggle('bg-transparent', !scrolled);
  };

  const setMobileOpen = (open) => {
    if (!toggleButton || !mobileMenu || !iconMenu || !iconClose) return;
    toggleButton.setAttribute('aria-expanded', String(open));
    toggleButton.setAttribute('aria-label', open ? closeLabel : openLabel);
    mobileMenu.classList.toggle('hidden', !open);
    iconMenu.classList.toggle('hidden', open);
    iconClose.classList.toggle('hidden', !open);
  };

  setScrolledState();
  window.addEventListener('scroll', setScrolledState, { passive: true });

  initLanguageDetection(header);

  if (toggleButton && mobileMenu && iconMenu && iconClose) {
    setMobileOpen(false);

    toggleButton.addEventListener('click', () => {
      const open = toggleButton.getAttribute('aria-expanded') === 'true';
      setMobileOpen(!open);
    });

    mobileLinks.forEach((link) => {
      link.addEventListener('click', () => setMobileOpen(false));
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768) setMobileOpen(false);
    });
  }
}
